module.exports = __webpack_public_path__ + "img/people-25.ca7f8bf5.png";